/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Component, OnInit, Input, SimpleChanges, ViewChild, Output, EventEmitter, ViewEncapsulation, AfterViewInit, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ButtonActionsService } from '@app/services/applyment/button-actions-service/button-actions.service';
import { FormioUtils as Utils, FormioComponent } from 'angular-formio';
import { FormioFunctions } from '@app/model/formio-functions.model';
import { ActivatedRoute, Router } from '@angular/router';
import { CepService } from 'src/app/modules/client/services/cep.service';
import { MatDialog, MatSnackBar } from '@angular/material';
import { NotificationComponent } from '@shared/components/notification/notification.component';
import { environment } from '@env';
import { returnsItemsInsideContent, getAllPossibleArrayCombinations } from '@shared/utils/util';
import { HTTPStatus } from '@app/clientHttp/http.interceptor';
import { delay } from 'rxjs/operators';
import { ApplymentModel } from '@app/services/client-general-settings/applyment/applyment.model';
import { options } from '@shared/shared.module';
import { ClientMainBarService } from 'src/app/layout/client/client-main-bar/client-main-bar.service';
import { Location } from '@angular/common';
import { TrackingService } from 'src/app/modules/client/services/tracking.service';
import { QueryParamsTrackingService } from '@app/services/applyment/query-params-tracking/query-params-tracking.service';

@Component({
  selector: 'app-form-render',
  templateUrl: './form-render.component.html'
})
export class FormRenderComponent implements OnInit, AfterViewInit {

  @Input() content;
  @Input() defaultColor? = false;
  @Input() data;
  @Input() lgpdDataFromPopUp = false;
  @Input() previousSubmissionDataFromPopUp = false;
  @Input() type;
  @ViewChild('formViewer', { static: false }) formViewer: FormioComponent;
  public triggerRefresh;
  public alternateFieldJson;
  public isUserDataPage = false;
  public logged;
  public form;
  public contentFields = [];
  public submission: any = {
    data: {}
  };
  public values_now = [];
  public urlParams;
  public rbParams;
  public useRbParams:boolean = false;
  public renderOptions = {
    executeScripts: true,
    editor: false,
    sanitizeConfig: {}
  };
  public options = {
    refreshOnChanged: true,
    alerts: {
      submitMessage: 'Submissão concluída.'
    },
    errors: {
      message: 'Falha no envio.'
    },
    i18n: {
      en: {
        error: '',
        invalid_date: '{{field}}  precisa ser uma data valida.',
        invalid_email: '{{field}} precisa ser um E-mail valido.',
        invalid_regex: '{{field}} não combina com o padrão regex',
        mask: '{{field}} não combina com a máscara.',
        max: '{{field}} não pode ser maior que {{max}}.',
        maxLength: '{{field}} precisa ser mais curto que {{length}} caracteres.',
        min: '{{field}} não pode ser menor que {{min}}.',
        minLength: '{{field}} precisa ser mais longo que {{length}} caracteres.',
        next: 'Próximo',
        pattern: '{{field}} does not match the pattern {{pattern}}',
        previous: 'Anterior',
        required: '{{field}} é obrigatório'
      },
    },
  };
  public institutional_color:string = "";
  public idsToCreateCopyElement = [];
  public previousSubmissionData: any;

  public relatedDataStorage = [];
  public relatedDataNextOptionsStorage = {};

  constructor(
    public buttonActionsService: ButtonActionsService,
    public formio: FormioFunctions,
    private activatedRoute: ActivatedRoute,
    private cepService: CepService,
    private snackBar: MatSnackBar,
    private ngZone: NgZone,
    private status: HTTPStatus,
    private router: Router,
    private applymentModel: ApplymentModel,
    private clientMainBarService: ClientMainBarService,
    private location: Location,
    private trackingService: TrackingService,
    private queryParamsTrackingService: QueryParamsTrackingService
    ) {}

  setForm(form) {
    this.form = form;
  }

  ngOnInit() {
    const rbParams = this.activatedRoute.snapshot.queryParamMap.get('rbParams');
    this.useRbParams = rbParams !== 'false' && !!rbParams;
    if(this.useRbParams) {
      this.handleTrackingQueryParams();
    } else {
      this.init();
    }
  }

  private handleTrackingQueryParams() {
    const params = this.queryParamsTrackingService.getParams();
    if (params) {
      this.rbParams = params;
      this.init();
    } else {
      const trackingLoaded = this.trackingService.checkTrackingAvailability();
      if (trackingLoaded) {
        this.getTrackingQueryParams();
      } else {
        setTimeout(() => { this.getTrackingQueryParams() }, 500);
      }
    }
  }

  private getTrackingQueryParams() {
   try {
    const methodResult = this.trackingService.getData((response) => this.callbackTrackingParams(response), () => this.init());
    if(methodResult === false) {
      this.init();
    }
   } catch (error) {
    this.init();
   }
  }

  private callbackTrackingParams(response) {
    if (response.success) {
      this.rbParams = response.data?.queryParams ?? false;
      this.queryParamsTrackingService.setParams(this.rbParams);
    }

    this.init();
  }

  public async init() {
    this.formio.stage = this.data?.stage_id ?? this.data?.currentStep?.stage_id; 
    this.institutional_color = this.applymentModel.getSettings().institutional_color;
    this.setInstitutionalColorCSSVariable();
    this.logged = this.applymentModel.getLogged();
    this.contentFields = returnsItemsInsideContent(this.content);
    this.triggerRefresh = new EventEmitter();
    
    this.activatedRoute.queryParams.subscribe(params => {
      this.urlParams = params;
      if (this.useRbParams) {
        this.urlParams = {
          ...this.urlParams ?? {},
          ...this.rbParams ?? {}
        }
      }
    });

    if (this.router.url.includes('pagina') && this.activatedRoute.snapshot.params['id'] == this.applymentModel.getSettings().user_details_page_id) {
      this.isUserDataPage = true;
    }

    const stateRoute:any = this.location.getState();
    this.previousSubmissionData = stateRoute.previousSubmissionData || [];

    this.setWindowData();
    await this.buildForm();
  }

  async waitToFormIOToBeDefined() {
    const formviewer = this.formViewer;
    if(typeof formviewer !== 'undefined'){
      if (typeof formviewer.formio !== 'undefined') {
        await this.setFormFuncionalites(formviewer.formio);
      } else {
        setTimeout( () => {this.waitToFormIOToBeDefined()}, 250);
      }
    }
    else{
      setTimeout(() => {this.waitToFormIOToBeDefined()}, 100);
    }
  }

  ngAfterViewInit() {
    this.waitToFormIOToBeDefined();
  }

  async setFormFuncionalites(form) {
    if (form) {
      form.submission = this.submission;
      this.setPreviousDataOnForm();
      await this.setValuesOnForm();
      this.setOnChangeEventOnForm(form)
      this.buildSubmission();
    }
  }

  async setValuesOnForm() {
    if (this.values_now.length > 0) {
      for (let index = 0; index < this.values_now.length; index++) {
        const value_now = this.values_now[index];
        const component = Utils.getComponent(this.formViewer.form.components, value_now.key, true);
        if (component) {
          if (component.multivalued) {
            value_now.value = this.convertValueNowToArray(value_now.value);
          }
          if (component.type === 'select') {
            const value = value_now.value || this.getAndRemovePreviousData(value_now.key);
            this.submission.data[value_now.key] = component.multivalued ? this.convertValueNowToArray(value) : String(value);
            if (component.first) {
              await this.configureSelectChildOptions(component, this.submission.data, this.nextChildSelectCallback);
            }
          } else if(component.type === 'radio') {
            if(Array.isArray(value_now.value) && value_now.value.length > 0) {
              value_now.value = value_now.value[0];
            }
            this.submission.data[value_now.key] = value_now.value;
          } else if (component.provide === undefined) {
            this.submission.data[value_now.key] = value_now.value;
            if (component.type === 'checkbox') {
              this.submission.data[value_now.key] = String(value_now.value) == '1' ? true : false;
            }
            if (this.getCepKey(component.key) === 'cep') {
              this.submission.data[value_now.key] = this.getApplicantDataByfieldId(component.field_id_to_save_cep);
            }
          }
        }
      };
    }
  }

  private setPreviousDataOnForm() {
    if(!this.previousSubmissionData) {
      return;
    }

    const previousData = [...this.previousSubmissionData];
    
    previousData.forEach(element => {
      if(element.value) {
        if(!this.submission.data[element.key]) {
          this.submission.data[element.key] = String(element.value);
        }
      }
    });
  }

  private getAndRemovePreviousData(key) {
    if(!this.previousSubmissionData.length) {
      return '';
    }

    const index = this.previousSubmissionData.findIndex(e => e.key == key);
    if(index === -1) {
      return '';
    }

    const value = this.previousSubmissionData[index].value;
    this.previousSubmissionData.splice(index, 1);
    return value ?? '';
  }

  convertValueNowToArray(value_now) {
    if (Array.isArray(value_now)) {
      return value_now;
    }
    try {
      const valueArray = JSON.parse(value_now);
      if (Array.isArray(valueArray)) {
        if (!this.isEmpty(valueArray)){
          return valueArray;
        }
        return [];
      }
      return [String(valueArray)]
    } catch (error) {
      return [];
    }
  }

  private isEmpty(value) {
    if (Array.isArray(value)) {
        return this.isEmpty(value[0]);
    }
    return !value;
  } 

  private setInstitutionalColorCSSVariable() {
    document.documentElement.style.setProperty('--institutional-color', this.institutional_color);
  }

  private nextChildSelectCallback = async (comp, data) => {
    await this.configureSelectChildOptions(comp, data, this.nextChildSelectCallback);
  }

  private setOnChangeEventOnForm(form) {
    form.on('render', () => {
      this.createLogOutButton();
      this.createCopyTextButton();
    })
    form.on('change', async (changed) => {
      if (changed.changed) {
        const key = changed.changed.component.key;
        const value = changed.changed.value;
        const data = changed.data;
        
        // procura o componente que foi alterado
        const component = Utils.getComponent(this.formViewer.form.components, key, true);
        if (value === null && data[key] === undefined) {
          data[key] = "";
        }

        this.callCepApi(component, value, changed);
        await this.configureSelectChildOptions(component, data, this.nextChildSelectCallback);
        this.createCopyTextButton();
      }
    });
  }

  private createCopyTextButton() {
    this.idsToCreateCopyElement.forEach((element)=>{
      const field = document.getElementsByName(`data[${element}]`)[0];
      if(field){
        const idSpanIconCopy = `copy-${element}`
        let spanIconCopy = document.getElementById(idSpanIconCopy);
        
        if(!spanIconCopy) {
          spanIconCopy = document.createElement('span');
          spanIconCopy.classList.add('material-icons');
          spanIconCopy.innerText='content_copy';
          spanIconCopy.setAttribute('style','margin-left: 3px');
          spanIconCopy.setAttribute('id',idSpanIconCopy);

          const inputGroup = field.parentNode;
          let suffixDiv = Array.from(inputGroup.children).find((element)=>element.getAttribute('ref') ==='suffix');

          if(!suffixDiv) {
            Object(inputGroup).classList.add('input-group');
            suffixDiv = document.createElement('div');
            suffixDiv.setAttribute('ref','suffix');
            suffixDiv.classList.add('input-group-append');
            inputGroup.appendChild(suffixDiv);
          }

          Object(suffixDiv).style.cursor = 'pointer';
          Object(suffixDiv).style.alignItems = 'center';
          suffixDiv.addEventListener('click', () => this.copyTextToClipboard(field));
          suffixDiv.appendChild(spanIconCopy);
        }
      }
    });
  }

  private copyTextToClipboard(field):void {
    if(field.disabled) {
      field.disabled = false;
      field.select();
      field.blur();
      field.disabled = true;
    } else {
      field.select();
      document.execCommand('copy');
      field.blur();
    }
    this.showSuccessMessage('Copiado com sucesso!');
  }

  private createLogOutButton() {
    let element = document.getElementById('description-link');
    if (element) {
      element.innerHTML = '';
      const description = document.createElement('span');
      description.innerText = 'Você já está logado! Para fazer inscrição para outra pessoa é necessário sair de sua sessão: ';
      element.appendChild(description);
      const link = document.createElement('a');
      link.innerText = "Sair";
      link.setAttribute('style',  `
      color: ${this.institutional_color ?? '#10807f'}!important;
      text-decoration: none !important;
      background-color: transparent !important;
      cursor: pointer !important;
      `);
      link.addEventListener('click', () => {
        this.applymentModel.setLogged(this.clientMainBarService.clearSession());
      });
      element.appendChild(link);
    }
  }

  private getCepKey(key) {
    if (typeof key === "string") {
      const splitKey = key.split("-");
      return splitKey[0];
    }
    return key;
  }

  private checkCepIsValid(component, value, changed) : boolean {
    if (!component) return false;
    if (this.getCepKey(component.key) === 'cep' && value && !value.includes('_')) {
      return true;
    }
    return false
  }

  private callCepApi(component, value, changed) {
    if (this.checkCepIsValid(component, value, changed)) {
      this.cepService.getCepDetails(component.id, value).pipe(delay(0)).subscribe(
        response => this.successCallCepApi(response),
        error => this.errorCallCepApi(error)
      );
    }
  }

  successCallCepApi(response) {
    if (response.success && response.data) {
      this.findCepFieldsToFill(response.data, this.contentFields);
    }
    this.triggerRefresh.emit({property: 'form', form: this.formViewer.form});
  }

  findCepFieldsToFill(cep_fields, array) {
    array.forEach((component) => {
      const componentData = component.component?? component;
      this.fillCepFieldsWithCepDetails(cep_fields, componentData);
    })
  }

  fillCepFieldsWithCepDetails(cep_fields, component) {
    this.fillStateFieldWithCepDetail(component, cep_fields);
    this.fillCityFieldWithCepDetail(component, cep_fields);
    this.fillDistrictFieldWithCepDetail(component, cep_fields);
    this.fillAddressFieldWithCepDetail(component, cep_fields);
  }

  fillStateFieldWithCepDetail(component, cep_fields) {
    if (component.field_id && component.field_id == cep_fields.state_id) {
      this.submission.data[component.key] = cep_fields.state;
    }
  }

  fillCityFieldWithCepDetail(component, cep_fields) {
    if (component.field_id && component.field_id == cep_fields.city_id) {
      this.submission.data[component.key] = cep_fields.city;
    }
  }

  fillDistrictFieldWithCepDetail(component, cep_fields) {
    if (component.field_id && component.field_id == cep_fields.district_id) {
      this.submission.data[component.key] = cep_fields.district;
    }
  }

  fillAddressFieldWithCepDetail(component, cep_fields) {
    if (component.field_id && component.field_id == cep_fields.address_id) {
      this.submission.data[component.key] = cep_fields.address;
    }
  }

  errorCallCepApi(error) {
    const body = error.error;
    if (body.data === 'offline') {
      const message = `Não foi possível buscar as informações de CEP.
      Serviço indisponível no momento.
      Preencha manualmente os campos de endereço`;
      this.showErrorMessage(message);
    } else {
      this.showErrorMessage(body.data);
    }
  }

  showErrorMessage(message) {
    this.ngZone.run(() => {
      this.snackBar.openFromComponent(NotificationComponent, {
        panelClass: 'alert',
        duration: 5000,
        data: {
          title: 'Atenção!',
          msg: message,
          act: 'OK',
          type: 'alert'
        }
      });
    });
  }

  showSuccessMessage(message) {
    this.ngZone.run(() => {
      this.snackBar.openFromComponent(NotificationComponent, {
        panelClass: 'success',
        duration: 5000,
        data: {
          msg: message,
          act: 'Fechar',
          type: 'success'
        }
      });
    });
  }

  private changeCheckboxToSelectbox(component) {
    if (component.field_type_id !== 1) {
      return false;
    }

    if (component.multivalued === 0) {
      return false;
    }

    let form_build = JSON.parse(component.form_build)
    form_build.type = 'selectboxes';
    component.form_build = JSON.stringify(form_build);
  }

  private configureSelectBoxes(formBuild, component) {
    if (formBuild.type !== 'selectboxes') {
      return false;
    }

    if (component.predefined_source_options !== 1) {
      return false;
    }

    if (component.defined_source === 1) { // TOTVS
      this.setOptionsFromTotvsSourceOnRadioButton(formBuild, component);
    }
    
    if (component.defined_source === 2) { // Fonte externa
      formBuild.values = component.data;
    }
    
    if (component.defined_source === 3) { // Opções manuais
      formBuild.values = [];
      component.data.forEach(element => {
        formBuild.values.push({'value' : element.value, 'label' : element.display})
      });
    }
  }
  
  async buildForm() {
    const form: any = this.getFormInitialTemplate();
    let currentTarget = form.components[0].columns[0].components;
    let currentElement;
    let columnSize = [];
    let columnId = '';
    let currentTargetIndex = 0;
    currentElement = null;

    for (let index = 0; index < this.content.length; index++) {
      const comp = this.content[index];

      if (comp.form_build) {
        this.changeCheckboxToSelectbox(comp);
        const interpolatedElement = this.interpolate(JSON.stringify(JSON.parse(comp.form_build)));
        let formBuild = {};
        try {
          formBuild = JSON.parse(interpolatedElement);
        } catch (error) {
          return console.warn(`Ocorreu um erro ao tentar renderizar o componente.\n Erro: ${error}`);
        }
        const column = this.getColumnInitialTemplate();
        if (formBuild) {
          this.configureCompProperties(formBuild, comp);
          await this.configureSelectOptions(formBuild, comp);
          this.configureRadioOptions(formBuild, comp);
          this.configureCheckBoxOptions(formBuild, comp);
          this.configureSelectBoxes(formBuild, comp);
          if (comp.type === 'container') {
            await this.buildContainer(comp, formBuild);
          }
          // montando as colunas
          if ((comp.column_index !== undefined && comp.column_index !== null) && comp.column_index > -1) {
            if ( columnId === comp.column_id ) {
              currentTarget[currentTargetIndex - 1].columns[comp.column_index].components.push(formBuild);
            } else {
                currentTarget = form.components;
                currentElement = column;
                columnId = comp.column_id;
                columnSize = Object.values(comp.column_size.split('-'));
                // tslint:disable-next-line: prefer-for-of
                for (let index = 0; index < columnSize.length; index++) {
                  const sizes = columnSize[index].split('.');
                  currentElement.columns.push({
                    components: [],
                    width: sizes[0],
                    size: typeof sizes[1] === 'undefined' || sizes[1] === 'undefined' ? 'md' : sizes[1],
                    offset: 0,
                    push: 0,
                    pull: 0
                  });
                }
                currentTargetIndex = currentTarget.push(currentElement);
                currentTarget[currentTargetIndex - 1].columns[comp.column_index].components.push(formBuild);
              }
          } else {
            currentTarget = form.components;
            currentTarget.push(formBuild);
          }
        }
      }
    };
    this.setForm(form);
  }

  async buildContainer(containerComponent, formBuild) {
    formBuild.components = [];
    const form = formBuild
    let currentTarget = form.components;
    let currentElement;
    let columnSize = [];
    let columnId = '';
    let currentTargetIndex = 0;

    if (containerComponent.container_background_type === 0) {
      formBuild.containerBackground = containerComponent.container_background_color;
    } else {
      formBuild.containerBackground = environment.storage_path + containerComponent.container_background_image;
    }
    formBuild.container_background_type = containerComponent.container_background_type;

    formBuild.container_css = containerComponent.container_css;
    formBuild.layout_direction = containerComponent.layout_direction;
    formBuild.layout_direction_alignment = containerComponent.layout_direction_alignment;
    formBuild.layout_perpendicular_alignment = containerComponent.layout_perpendicular_alignment;
    formBuild.max_width = containerComponent.max_width;
    formBuild.padding = containerComponent.padding;
    if(!formBuild.customClass){
      formBuild.customClass = "";
    }

    formBuild.customClass += " overflow-hidden ";

    currentElement = null;
    if (containerComponent.container_content.length > 0) {
      for (let index = 0; index < containerComponent.container_content.length; index++) {
        const elementOnContainer = containerComponent.container_content[index];
        if (elementOnContainer.form_build) {
          const interpolatedElement = this.interpolate(JSON.stringify(JSON.parse(elementOnContainer.form_build)));
          const ElementFormBuild = JSON.parse(interpolatedElement);
          const column = this.getColumnInitialTemplate();
          if ( ElementFormBuild ) {
            this.configureCompProperties(ElementFormBuild, elementOnContainer);
            this.configureSelectBoxes(ElementFormBuild, elementOnContainer);
            await this.configureSelectOptions(ElementFormBuild, elementOnContainer);
            this.configureRadioOptions(ElementFormBuild, elementOnContainer);
            this.configureCheckBoxOptions(ElementFormBuild, elementOnContainer);
            if (elementOnContainer.type === 'container') {
              await this.buildContainer(elementOnContainer, ElementFormBuild);
            }
            // montando as colunas
            if ((elementOnContainer.column_index !== undefined && elementOnContainer.column_index !== null) && elementOnContainer.column_index > -1) {
              if ( columnId === elementOnContainer.column_id ) {
                currentTarget[currentTargetIndex - 1].columns[elementOnContainer.column_index].components.push(ElementFormBuild);
              } else {
                currentTarget = form.components;
                currentElement = column;
                columnId = elementOnContainer.column_id;
                columnSize = Object.values(elementOnContainer.column_size.split('-'));
                // tslint:disable-next-line: prefer-for-of
                for (let index = 0; index < columnSize.length; index++) {
                  const sizes = columnSize[index].split('.');
                  currentElement.columns.push({
                    components: [],
                    width: sizes[0],
                    size: typeof sizes[1] === 'undefined' || sizes[1] === 'undefined' ? 'md' : sizes[1],
                    offset: 0,
                    push: 0,
                    pull: 0
                  });
                }
                currentTargetIndex = currentTarget.push(currentElement);
                currentTarget[currentTargetIndex - 1].columns[elementOnContainer.column_index].components.push(ElementFormBuild);
              }
            } else {
              currentTarget = form.components;
              currentTarget.push(ElementFormBuild);
            }
          }
        }
      };
    }
  }

  configureFieldValidators(formBuild) {

    if (this.checkRequired(formBuild)) {
      formBuild.isRequired = true;
    } else {
      formBuild.isRequired = false;
    }

    if (formBuild.validatorData.enable) {
      if (formBuild.validatorData.data.length > 0) {
        // tslint:disable-next-line: max-line-length
        formBuild.validate.custom = `valid = window.formFunctions.testValidatorsLogic(component, input)`;
      }
    } else {
      formBuild.validate = {};
    }
  }

  buildSubmission() {
    const use_totvs_oracle = this.checkIfItUseOracle();
    let data: any = [];
    // pega os dados retornados em querys do passo e do feedback
    if (this.type === 1) {
      if (
        this.data.stepsData.stage &&
        this.data.stepsData.stage.query &&
        this.data.stepsData.stage.query.query_data
        ) {
          data = this.data.stepsData.stage.query.query_data[0];
      }
    } else {
      if (
        this.data.query && this.data.query.length > 0
        ) {
          this.data.query.map((query: any) => {
            if (query.query_data && Array.isArray(query.query_data)) {
              query.query_data.map((e) => {
                data.push(e);
              });
            }
          });
      }
    }
    if (data) {
      const elementList = [...this.contentFields.filter((element) => element?.field_id)];
      Object.keys(data).map((key: any) => {
        let keyName = this.getKeyName(key,use_totvs_oracle);
        elementList.map((item, i) => {
          if (item.field_id && item.totvs_table !== null && item.totvs_field !== null) {
            const fieldKey = use_totvs_oracle ? item.totvs_alternative_name : `${item.totvs_table}.${item.totvs_field}`;
            if(keyName.toLowerCase() === fieldKey.toLowerCase()) {
              this.submission.data[item.key] = String(data[fieldKey]);
            }
          }
        });
      });
    }
  }

  private getKeyName(key: any, use_totvs_oracle = false): string {
    if(use_totvs_oracle) {
      return key;
    }

    key = key.split('.');
    const totvsTable = key[0];
    let totvsField = '';
    key.map((value, index) => {
      if (index !== 0) {
        if ((key.length - 1) === index) {
          totvsField += value;
        } else {
          totvsField += value+'.';
        }
      }
    });

    return `${totvsTable}.${totvsField}`;
  }
  
  getFormInitialTemplate() {
    return {
      components: [
        {
          label: 'Columns',
          columns: [
          {
            components: [],
            width: 12,
            offset: 0,
            push: 0,
            pull: 0
          }
          ],
          tableView: false,
          key: 'columns',
          type: 'columns',
          input: false
        }
      ]
    };
  }

  getColumnInitialTemplate() {
    return  {
      label: 'Columns',
      columns: [],
      tableView: true,
      key: 'columns',
      type: 'columns',
      autoAdjust: true,
      input: false
    }
  }

  interpolate(element) {
    let systemFields = null;
    if (this.data.stepsData) {
      systemFields = this.data.stepsData.steps.currentStep.applicantData;
    } else {
      systemFields = this.data.applicantData;
    }
    element = element.replace(/#{@[^@}\r\n]*@}/gim, (val) => {
      let variable = val;
      variable = val.replace(/<[^>]*>/g, '');
      variable = variable.replace(/#{@/, '');
      variable = variable.replace(/@}/, '');
      let systemValue = null;
      if (typeof systemFields !== 'undefined' && systemFields) {
        systemFields.forEach(field => {
          if (variable == field.field_id) {
            systemValue = field.value;
          }
        });
      }

      if (systemValue === null || systemValue === undefined || systemValue === '') {
        systemValue = '';
      }
      // tslint:disable-next-line: max-line-length
      return  `{{ (data['${variable}'] === '' || data['${variable}'] === null || data['${variable}'] === undefined) ? '${this.escapeHtml(systemValue)}' : row['${variable}'] }}`;
    });
    return element;
  }

  escapeHtml(value) {
    return value
        .replace(/(?:\r\n|\r|\n)/g, `<br>`)
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
  }

  configureRadioOptions(formBuild, comp) {
    if (comp.field_type_id !== 7) { // Verifica se é um radio button
      return formBuild;
    }

    if (!formBuild.values) {
      formBuild.values = [];
    }
    if (comp.data && comp.data.length > 0) {
      if (comp.defined_source === 1) {
        this.setOptionsFromTotvsSourceOnRadioButton(formBuild, comp);
      } else if (comp.defined_source === 2) {
        this.setOptionsFromExternalSourceOnRadioButton(formBuild, comp)
      } else {
        this.setOptionsFromManualSources(formBuild, comp);
      }
    } else if (comp.manual_options && comp.manual_options.length > 0) {
      this.setOptionsFromManualSources(formBuild, comp);
    }
  }

  configureCheckBoxOptions(formBuild, comp) {
    if (comp.field_type_id !== 1) {
      return false;
    }

    if (formBuild.type !== 'checkbox') {
      return false;
    }

    if (!formBuild.values) {
      formBuild.values = [];
    }
    if (comp.data && comp.data.length > 0) {
      if (comp.defined_source === 1) {
        this.setOptionsFromTotvsSourceOnRadioButton(formBuild, comp);
      } else {
        this.setOptionsFromExternalSourceOnRadioButton(formBuild, comp)
      }
    }
  }

  setOptionsFromTotvsSourceOnRadioButton(formBuild, comp) {
    if (!Array.isArray(comp.data)) {
      formBuild.hidden = true;
      return
    }
    comp.data.forEach(option => {
      let value: any;
      let label: any;
      Object.keys(option).map((key: any) => {
        if (this.isCod(key)) {
          value = option[key];
        }
        if (this.isDisplay(key)) {
          label = option[key];
        }
      })
      if (value && label) {
        formBuild.values.push({value, label});
      }
    });
  }


  setOptionsFromExternalSourceOnRadioButton(formBuild, comp) {
    if (!Array.isArray(comp.data)) {
      formBuild.hidden = true;
      return
    }
    comp.data.forEach(option => {
      if (option.display && option.value) {
        formBuild.values.push({
          value: option.value,
          label: option.display
        });
      }
    });
  }

  setOptionsFromManualSources(formBuild, comp) {
    if (comp.data && comp.data.length > 0) {
      formBuild.values = [];
      comp.data.forEach(option => {
        if (option.display && option.value) {
          formBuild.values.push({
            value: option.value,
            label: option.display
          });
        }
      });
    } else if (comp.manual_options && comp.manual_options.length > 0) {
      formBuild.values = [];
      comp.manual_options.forEach(option => {
        if (option.display && option.value) {
          formBuild.values.push({
            value: option.value,
            label: option.display
          });
        }
      });
    } else {
      formBuild.hidden = true;
    }
  }

  isCod(key) {
    if (key.toLowerCase().startsWith('cod.') || key.toLowerCase().startsWith('c_')) {
      return true;
    }
    return false;
  }

  isDisplay(key) {
    if (key.toLowerCase().startsWith('display.') || key.toLowerCase().startsWith('d_')) {
      return true;
    }
    return false;
  }

  async configureSelectOptions(formBuild, comp) {
    if (comp.field_type_id !== 11) {
      let value = "";
      if (comp.value_now !== undefined && comp.value_now !== null) {
        value = comp.value_now;
      } else if (comp.data_type === 1 || comp.data_type === 3) {
        value = this.textTransformIfNeeded(formBuild,comp,comp.data_value);
      } else if (comp.data_type === 2 && this.urlParams[comp.data_value] !== undefined) {
        value = this.textTransformIfNeeded(formBuild, comp, this.urlParams[comp.data_value]);
      } 
      this.values_now.push({key: formBuild.key, value: value})
      return formBuild;
    }

    // coloca as opções em campos não vinculados
    if (comp.data && comp.data.length > 0) {
      formBuild.data = {
        values:  []
      };
      if (comp.defined_source === 1) {
        if (comp.data && Array.isArray(comp.data)) {
          comp.data.map((item) => {
            let value = false;
            let display = false;
            Object.keys(item).map((key: any) => {
              if (this.isCod(key)) {
                value = item[key];
              }
              if (this.isDisplay(key)) {
                display = item[key];
              }
            });
            if ( value && display ) {
              formBuild.data.values.push({value, label: display});
            }
          });
        } else if (comp.lazy_load && comp.data) {
          formBuild.lazy_load = comp.lazy_load ?? 0;
          formBuild.data_source = comp.data ?? "";
          formBuild.data.values = await this.formio.getOptionsFromServer(comp.data, comp.field_id, false, [], [], true);
        }
      } else {
        if (comp.data && Array.isArray(comp.data)) {
          comp.data.map(item => {
            if (item.display && item.value) {
              formBuild.data.values.push({ value: item.value, label: item.display });
            }
          });
        } else if(comp.lazy_load && comp.data) {
          formBuild.lazy_load = comp.lazy_load ?? 0;
          formBuild.data_source = comp.data ?? "";
          formBuild.data.values = await this.formio.getOptionsFromServer(comp.data, comp.field_id, false, [], [], true);
        }
      }

      if (comp.value_now !== undefined && comp.value_now !== null) {
        this.values_now.push({key: formBuild.key, value: comp.value_now})
      } else if (comp.data_type === 1 || comp.data_type === 3) {
        this.values_now.push({key: formBuild.key, value: comp.data_value})
      } else if (comp.data_type === 2 && this.urlParams[comp.data_value] !== undefined) {
        const option = this.getOption(formBuild.data.values, this.urlParams[comp.data_value]);
        if (option) {
          this.values_now.push({key: formBuild.key, value: String(option.value)})
        } else {
          this.values_now.push({key: formBuild.key, value: this.urlParams[comp.data_value]})
        }
      } else if (formBuild.data && formBuild.data.values && formBuild.data.values.length === 1) {
        this.values_now.push({key: formBuild.key, value: String(formBuild.data.values[0].value)});
      } else {
        this.values_now.push({key: formBuild.key, value: ""})
      }

      // coloca as opções em campos vinculados
    } else if (comp.field_relation && comp.field_relation.length > 0 ) {
        formBuild.provide = [];
        formBuild.nextFields = [];
        // Verifica qual é o primeiro campo na relação
        const relation = this.handleFieldPositionsAndReturnFirst(comp, formBuild);

        formBuild.relation_id = comp.relation_id;

        if (comp.lazy_load) {
          formBuild.lazy_load = comp.lazy_load ?? 0;
          formBuild.data_source = comp.related_data ?? "";
        }

        if (relation) {
          formBuild.data = {
            values:  []
          };

          formBuild.first = true;
          if (comp.related_data && Array.isArray(comp.related_data) && comp.related_data.length > 0) {
            const { options }: { hasInvalidLabel: boolean, options: Array<any> } = this.getFilteredOptions(false, comp.related_data, comp);
            formBuild.data.values = options;
          } else if(comp.lazy_load) {
            const data = await this.formio.getOptionsFromServer(comp.related_data, comp.field_id, comp.relation_id, [], formBuild.nextFields, true) as any;
            if (data.options) {
              formBuild.data.values = data.options;
              if (data.nextOptions) {
                this.relatedDataNextOptionsStorage[comp.relation_id] = data.nextOptions;
              } 
            } else {
              formBuild.data.values = data;
            }
          }

          if (comp.value_now !== undefined && comp.value_now !== null && comp.value_now !== "") {
            this.values_now.push({key: formBuild.key, value: comp.value_now})
          } else if (comp.data_type === 1 || comp.data_type === 3) {
            this.values_now.push({key: formBuild.key, value: comp.data_value})
          } else if (comp.data_type === 2 && this.urlParams[comp.data_value] !== undefined) {
            const option = this.getOption(formBuild.data.values, this.urlParams[comp.data_value]);
            if (option) {
              this.values_now.push({key: formBuild.key, value: String(option.value)})
            } else {
              this.values_now.push({key: formBuild.key, value: this.urlParams[comp.data_value]})
            }
          } else if (formBuild.data && formBuild.data.values && formBuild.data.values.length === 1) {
            this.values_now.push({key: formBuild.key, value: String(formBuild.data.values[0].value)});
          } else {
            this.values_now.push({key: formBuild.key, value: ""})
          }

        } else {
          if (comp.value_now === undefined || comp.value_now === null) {
            if (comp.data_type === 1 || comp.data_type === 3) {
              const value = comp.data_value;
              formBuild.value_now = value;
              this.values_now.push({key: formBuild.key, value})
            } else if (comp.data_type === 2 && this.urlParams[comp.data_value] !== undefined) {
              const value = this.urlParams[comp.data_value];
              formBuild.value_now = value;
              this.values_now.push({key: formBuild.key, value})
            }
          }
        }
    }
    return formBuild;
  }
  

  textTransformIfNeeded(formBuild, comp, value){
    if(typeof value !== 'string' || comp.field_type_id != 9) {
      return value;
    }
    
    if(formBuild.case === 'uppercase'){
       return value.toUpperCase();
    }
    if(formBuild.case === 'lowercase'){
      return value.toLowerCase();
    }
    return value;
  }

  setAttributes(formBuild, comp) {
    formBuild.attributes = {}
    const maxLength = this.getMaxLength(formBuild);

    if(comp.read_only) {
      formBuild.attributes.readonly = true;
    }

    if(maxLength && !formBuild.inputMask){
      formBuild.attributes.maxlength = maxLength;
    }
  }

  configureCompProperties(formBuild, comp) {
    // coloca dados que serão uteis em diversos metodos do formulario
    formBuild.id = comp.id;
    formBuild.key = comp.key;

      if (comp.field_id) {
        formBuild.field_id = comp.field_id;
        formBuild.key = comp.field_id;
        if(JSON.parse(comp.form_build).copy) {
          this.idsToCreateCopyElement.push(comp.field_id);
        }
      }
      comp.properties = comp.properties ?? {};
      formBuild.properties = comp.properties;

      this.setAttributes(formBuild, comp);

      formBuild.isDisabled = !!formBuild?.disabled;
      formBuild.clearOnHide = false;

      formBuild.lgpdDataFromPopUp = this.lgpdDataFromPopUp;
      formBuild.previousSubmissionDataFromPopUp = this.previousSubmissionDataFromPopUp;
      formBuild.rbParams = this.rbParams;
  
      if (comp.field_id_related_to_component) {
        formBuild.field_id_related_to_component = comp.field_id_related_to_component;
        formBuild.key = formBuild.field_id_related_to_component;
      }
      
      formBuild.value_now = comp.value_now;

      if (formBuild.validatorData) {
        this.configureFieldValidators(formBuild);
      }

      if (comp.field_id_to_save_cep) {
        formBuild.field_id_to_save_cep = comp.field_id_to_save_cep;
        formBuild.key = "cep-" + comp.field_id_to_save_cep;
      }

      if (comp.payment_status_field_id) {
        formBuild.payment_status_field_id = comp.payment_status_field_id;
      }

      if (comp.rubeus_table !== undefined) {
        formBuild.rubeus_table = comp.rubeus_table;
      }

      if (comp.totvs_table !== undefined) {
        formBuild.totvs_table = comp.totvs_table;
      }

      if (comp.totvs_field !== undefined) {
        formBuild.totvs_field = comp.totvs_field;
      }

      if (comp.totvs_alternative_name !== undefined) {
        formBuild.totvs_alternative_name = comp.totvs_alternative_name;
      }

      if (comp.ps_table !== undefined) {
        formBuild.ps_table = comp.ps_table;
      }

      if (comp.multivalued) {
        formBuild.multiple = true;
        formBuild.multivalued = true;
        formBuild.max_multivalued_options = comp.max_multivalued_options;
        formBuild.min_multivalued_options = comp.min_multivalued_options;
      } else {
        formBuild.multivalued = false;
      }

      if (comp.store_data) {
        formBuild.store_data = comp.store_data;
      }

      if (comp.type === 'upload') {
        if (comp.upload_content) {
          formBuild.upload_content = comp.upload_content;
        }
        formBuild.upload_multiple_files = comp.upload_multiple_files;
        formBuild.block_attaching_reject_files = comp.block_attaching_reject_files;
        formBuild.component_upload_file_types = comp.component_upload_file_types;
      }

      if (comp.type === 'lgpd') {
        formBuild.lgpd_content = comp;
      }

      if (comp.type === 'button') {
        formBuild.disableOnInvalid = false;
        formBuild.disableOnInvalid = false;
        formBuild.related_component_id = comp.related_component_id;
        if (formBuild.externalColor === 'default' && this.defaultColor) {
          formBuild.externalColor = this.defaultColor;
        }
        if (formBuild.internalColor === 'default' && this.defaultColor) {
          formBuild.internalColor = this.defaultColor;
        }
      }

      if (comp.type === 'radio') {
        formBuild.dataType = 'string';
      }

      if (comp.type === 'html') {
        const formatedAttributes = [];
        if (Array.isArray(comp.parameters) && comp.parameters.length > 0) {
          comp.parameters.forEach(parameter => {
            if (parameter.parameter_type_id == 2) {
              formatedAttributes.push({attr: parameter.name, value: parameter.fixed_value});
            }
            if (parameter.parameter_type_id == 1) {
              formatedAttributes.push({attr: parameter.name, value: this.getApplicantDataByfieldId(parameter.field_id)});
            }
          });
        }
        formBuild.attrs = formatedAttributes;
      }

      formBuild.live = true;

      if (formBuild.hidde === true) {
        formBuild.customClass = 'ps-input-hidden';
      }

      formBuild.optionPath = formBuild.label;

      // coloca o simbolo * de requerido
      if (formBuild.isRequired) {
        formBuild.label = formBuild.label + ' *';
      }

      // configura o código que gerencia a lógica
      if (formBuild.conditionalData) {
        formBuild.conditionalData.data = this.formatContional(comp.logics);
        const data = formBuild.conditionalData;
        if (data.enable && data.data.length > 0) {
          formBuild.customConditional = `
          const resultArray = [];
          const condition = component.conditionalData.condition;
          const action = component.conditionalData.action;
          component.conditionalData.data.forEach((val) => {
            let result = window.formFunctions.testLogic(val, data[val.key], form);
            if (result !== null) {
              resultArray.push(result);
            }
          });
          const result = window.formFunctions.checkLogicTestsResults(resultArray, condition, action);
          return result;
          `;
        }
      }

      // this.applymentModel.getSettings().user_details_page_id;
      if ((comp.is_name_field && this.logged) && !this.isUserDataPage) {
        formBuild.disabled = true;
        formBuild.description = `<b id="description-link">Você já está logado! Para fazer inscrição para outra pessoa é necessário sair de sua sessão</b>`;
      }

      return formBuild;
  }

  getLinkStyle() {
    return  'color: #009688; text-decoration: none; background-color: transparent; cursor: pointer';
  }

  checkRequired(formBuild) {
    return (formBuild.validatorData && (formBuild.validatorData.enable === true && formBuild.validatorData.data &&
    formBuild.validatorData.data.length > 0) &&
    ((formBuild.validatorData.data[0].key === 'required' ||
      formBuild.validatorData.data[0].key === 'requiredNumber' ||
      formBuild.validatorData.data[0].key === 'requiredCheck') &&
      (formBuild.validatorData.data[0].value === true)))
  }

  getMaxLength(formBuild) {
    if (formBuild.validatorData && (formBuild.validatorData.enable === true && formBuild.validatorData.data && formBuild.validatorData.data.length > 0)){
      for(const index in formBuild.validatorData.data){
        if (formBuild.validatorData.data[index].key == 'maxLength'){
          return formBuild.validatorData.data[index].value;
        }
      }
    }

    return false;
  }

  formatContional(logics) {
    const conditionalData = [];
    logics.forEach(logic => {
      conditionalData.push({
          key: logic.field_compare_id,
          operator: logic.rule_logic_id,
          value: logic.fixed_value,
          systemValue: logic.system_value
      })
    });
    return conditionalData;
  }

  handleFieldPositionsAndReturnFirst(comp, formBuild) {
    let relation: any = false;
    let firstRelation: any = false;
    const relatedFields = [];
    // pega os campos relacionados nessa relação
    firstRelation = this.getRelatedFieldsAndFirstRelation(relatedFields, comp.relation_id);
    // pega as posições dos campos relacionados nessa relação
    const positions = this.getSelectFieldPositions(relatedFields);
    // checa se o valor é o primeiro ou desabilita ele
    if (positions.length > 0) {
      if (positions[0].field_id === comp.field_id) {
        relation = firstRelation;
      } else {
        positions.map((pos) => {
          if (pos.field_id !== comp.field_id) {
            formBuild.disabled = true;
          }
        });
      }
    }

    this.setProvideArrayAndSelectPosition(positions, comp, formBuild);
    return relation;
  }

  setProvideArrayAndSelectPosition(positions, comp, formBuild) {
    formBuild.field_relation = [];
    positions.map((pos, index) => {
      if (pos.field_id !== comp.field_id) {
        formBuild.provide.push(pos.field_id);
      } else {
        formBuild.positionOnSelect = index;
      }
      formBuild.field_relation.push({position: index, key: pos.key, field_id: pos.field_id});
    });

    positions.map((pos, index) => {
      if (index > formBuild.positionOnSelect) {
        formBuild.nextFields.push(pos.field_id);
      }
    })
  }

  getSelectFieldPositions(relatedFields) {
    const positions = [];
    this.contentFields.map((field) => {
      if (relatedFields.includes(field.field_id)) {
        positions.push({position: field.field_id, field_id: field.field_id, key: field.key});
      }
    });
    return positions;
  }

  getRelatedFieldsAndFirstRelation(relatedFields, relationId) {
    let firstRelation: any = false;
    this.contentFields.map(field => {
      if (field.field_relation) {
        field.field_relation.map((rel) => {
          if (field.relation_id === relationId) {
            relatedFields.push(rel.field_id);
            if (rel.field_id === field.field_id) {
              if (firstRelation === false) {
                firstRelation = rel;
              }
            }
          }
        });
      }
    });
    return firstRelation;
  }

  async configureSelectChildOptions(component, data, callback) {
    if (component && component.provide && component.provide.length > 0) {
      let needCallback : boolean | Promise<boolean> = false;
      let next;
      const selectPosition = component.positionOnSelect;
      for (let index = 0; index < component.provide.length; index++) {
        const relatedFieldId = component.provide[index];
        const childComp = Utils.getComponent(this.formViewer.form.components, relatedFieldId, true);
        if (childComp) {
          const childSelectPosition = childComp.positionOnSelect;
          if (selectPosition + 1 === childSelectPosition) {
            if (component.properties?.cleaning) {
              childComp.data = {
                values: []
              };
              this.clearChildSelectDataAndDisable(data, childComp);
            } else {
              needCallback = await this.handleNextSelect(childComp, data);
              next = {
                comp: childComp,
                data: data
              }
            }
          }
          if (selectPosition + 1 < childSelectPosition ) {
            this.handleSucceedingSelect(childComp);
          }
        }
      }
      component.properties.cleaning = false;
      if (needCallback && next) {
        return await callback(next.comp, next.data)
      } else {
        this.triggerRefresh.emit({property: 'form', form: this.formViewer.form});
      }
    }
  }



  async handleNextSelect(childComp, data) {
    const selectedOptions = childComp.lazy_load ? this.getPreviousSelectedOptionsForServer(childComp, data) : this.getPreviousSelectedOptions(childComp, data);
    if (selectedOptions.length > 0) {
      const { hasInvalidLabel, options } : { hasInvalidLabel: boolean, options: Array<any> } = childComp.lazy_load ? await this.getFilteredOptionsOnServer(selectedOptions, childComp) : this.getFilteredOptions(selectedOptions, this.getRelatedData(childComp.key), childComp);
      
      childComp.data = {
        values: options
      };

      childComp.value_now = childComp.value_now || this.getAndRemovePreviousData(childComp.key);
      if (childComp.value_now !== undefined && childComp.value_now !== null && childComp.value_now !== "") {
        if (childComp.multivalued) {
          childComp.value_now = this.convertValueNowToArray(childComp.value_now);
        }

        const option = this.getOption(childComp.data.values, childComp.value_now);
        
        if (option) {
          this.submission.data[childComp.key] = String(option.value);
        } else {
          this.submission.data[childComp.key] = String(childComp.value_now);
        }

        childComp.disabled = false;
        childComp.value_now = undefined;
        return true;
      } else {
        if (childComp.data.values.length === 1) {
          this.submission.data[childComp.key] = String(childComp.data.values[0].value);
          childComp.disabled = false;
          return true;
        } else {
          this.clearChildSelectDataAndDisable(data, childComp, hasInvalidLabel);
          return false;
        }
      }
    }
    childComp.data = {
      values: []
    };
    this.clearChildSelectDataAndDisable(data, childComp, false);
    return false;
  }

  handleSucceedingSelect(childComp) {
    childComp.data = {
      values: []
    };
    this.disableOrEnableSelect(childComp);
  }

  getPreviousSelectedOptionsForServer(childComp, data) {
    const selectedOptions = [];
    for (let index = 0; index < childComp.positionOnSelect; index++) {
        const previousSelect = Utils.getComponent(this.formViewer.form.components, childComp.field_relation[index].field_id, true);
        if (previousSelect) {
          const values = data[previousSelect.key];
          if (values && values.length > 0) {
            selectedOptions.push({field: previousSelect.field_id, values});
          }
        }
    }
    return selectedOptions;
  }

  getPreviousSelectedOptions(childComp, data) {
    const selectedOptions = [];
    let related_data = [];
    for (let index = 0; index < childComp.positionOnSelect; index++) {
      const previousSelect = Utils.getComponent(this.formViewer.form.components, childComp.field_relation[index].field_id, true);

      const valuesFromOneField = [];
      if (previousSelect) {
        const previousSelectRelatedData = this.getRelatedData(previousSelect.key);
        const values = data[previousSelect.key];
        if (Array.isArray(values)) {
          if (index === childComp.positionOnSelect - 1) {
            for (let index = 0; index < values.length; index++) {
              const value = values[index];
              const display = this.getOption(previousSelect.data.values, value);
              valuesFromOneField.push({value: value, field: previousSelect, display});
              if (previousSelectRelatedData) {
                related_data = related_data.concat(
                  previousSelectRelatedData[value] ?? []
                );
              }
            }
          } else {
            for (let index = 0; index < values.length; index++) {
              const value = values[index];
              const display = this.getOption(previousSelect.data.values, value);
              valuesFromOneField.push({value: value, field: previousSelect, display});
            }
          }
        } else {
          const display = this.getOption(previousSelect.data.values, values);
          valuesFromOneField.push({value: values, field: previousSelect, display});
          if (index === childComp.positionOnSelect - 1) {
            if (previousSelectRelatedData) {
              related_data = related_data.concat(
                previousSelectRelatedData[values] ?? []
              );
            }
          }
        }
      }
      this.setRelatedData(childComp.key, related_data);
      selectedOptions.push(valuesFromOneField);
    }
    return getAllPossibleArrayCombinations(selectedOptions);
  }

  getOption(options, value) {
    return options.find(option => option.value == value || option.label == value) ?? value;
  }

  disableOrEnableSelect(childComp, hasInvalidLabel = false) {
    if (childComp.data.values.length === 0 && !hasInvalidLabel) {
      childComp.disabled = true;
    } else {
      childComp.disabled = false;
    }
  }

  clearChildSelectDataAndDisable(data, childComp, hasInvalidLabel = false) {
    data[childComp.key] = '';
    if (childComp.data.values.length === 0 && !hasInvalidLabel) {
      childComp.disabled = true;
    } else {
      childComp.disabled = false;
    }
  }

  async getFilteredOptionsOnServer(selectedOptions, comp) {
    if (this.relatedDataNextOptionsStorage.hasOwnProperty(comp.relation_id) && this.relatedDataNextOptionsStorage[comp.relation_id].hasOwnProperty(comp.field_id)) {
      const options = this.relatedDataNextOptionsStorage[comp.relation_id][comp.field_id];
      delete this.relatedDataNextOptionsStorage[comp.relation_id][comp.field_id];
      return {
        hasInvalidLabel: false,
        options: [options]
      }
    }
    const data = await this.formio.getOptionsFromServer(comp.data_source, comp.field_id, comp.relation_id, selectedOptions, comp.nextFields) as any;
    
    if (data.nextOptions) {
      this.relatedDataNextOptionsStorage[comp.relation_id] = data.nextOptions;
    } 

    if (data.options) {
      return {
        hasInvalidLabel: false,
        options: data.options
      }
    } else {
      return {
        hasInvalidLabel: false,
        options: data
      }
    }
  }

  getFilteredOptions(selectedOptions, data, comp): { hasInvalidLabel: boolean, options: Array<any> } {
    const use_totvs_oracle = this.checkIfItUseOracle();
    let options = [];
    let optionsByLabel = [];
    let hasInvalidLabel = false;
    if (comp.totvs_table && comp.totvs_field) {
      const keyParam = use_totvs_oracle ? `C_${comp.totvs_alternative_name}`.toUpperCase() : `COD.${comp.totvs_table.toUpperCase()}.${comp.totvs_field.toUpperCase()}`
      const displayParam = use_totvs_oracle ? `D_${comp.totvs_alternative_name}`.toUpperCase() : `DISPLAY.${comp.totvs_table.toUpperCase()}.${comp.totvs_field.toUpperCase()}`
      if (data) {
        if (Array.isArray(selectedOptions) && selectedOptions.length > 0 && Array.isArray(data)) {
          let groupedOptions: any = {};
          for (let index = 0; index < data.length; index++) {
            if(!this.isValidLabel(data[index][displayParam])) {
              hasInvalidLabel = true;
              continue;
            };
            const option = data[index];

            let duplicatedOption = options.find(opt => String(opt.value) === String(option[keyParam]) && opt.label == option[displayParam]) ?? null;
            let duplicatedOptionByLabel = optionsByLabel.find(opt => String(opt.value) === String(option[keyParam]) && opt.label == option[displayParam]) ?? null;

            this.getOptionsOfAllPaths(selectedOptions, option, keyParam, displayParam, options, optionsByLabel, duplicatedOption, duplicatedOptionByLabel);
            if (groupedOptions[option[keyParam]]) {
              groupedOptions[option[keyParam]].push(option);
            } else {
              groupedOptions[option[keyParam]] = [option];
            }
          }
          this.setRelatedData(comp.key, groupedOptions);
        } else if (selectedOptions === false){
          if (Array.isArray(data)) {
            let groupedOptions: any = {};
            for (let index = 0; index < data.length; index++) {
              if(!this.isValidLabel(data[index][displayParam])) {
                hasInvalidLabel = true;
                continue;
              };
              const option = data[index];
              let duplicated = options.find(opt => String(opt.value) === String(option[keyParam]) && opt.label == option[displayParam]) ?? null;
              if (duplicated) {
                duplicated = true;
              } else {
                duplicated = false;
              }
              if (!duplicated) {
                options.push({label: option[displayParam], value: String(option[keyParam])});
              }
              if (groupedOptions[option[keyParam]]) {
                groupedOptions[option[keyParam]].push(option);
              } else {
                groupedOptions[option[keyParam]] = [option];
              }
            }
            this.setRelatedData(comp.key, groupedOptions);
          }
        }
      }
    }
    return  {
      hasInvalidLabel,
      options: options.length ?  options : optionsByLabel
    }
  }

  getOptionsOfAllPaths(optionsPath: Array<any>, option, keyParam, displayParam, options, optionsByLabel, duplicatedOption, duplicatedOptionByLabel) {
    for (let index = 0; index < optionsPath.length; index++) {
      const path = optionsPath[index];
      const validOptionPath = this.filterOptions(path, option);
      const validOptionLabelPath = this.filterOptionsByLabel(path, option);

      if(validOptionPath) {
        if (duplicatedOption === null) {
          options.push({label: option[displayParam], value: String(option[keyParam]), path: validOptionPath});
        } else if(duplicatedOption.path && duplicatedOption.path !== validOptionPath &&  !duplicatedOption.path.includes(validOptionPath)) {
          duplicatedOption.path += ' | ' + validOptionPath;
          duplicatedOption.multiplePaths = true;
        }
      }

      if(validOptionLabelPath) {
        if (duplicatedOptionByLabel === null) {
          optionsByLabel.push({label: option[displayParam], value: String(option[keyParam]), path: validOptionLabelPath});
        } else if(duplicatedOptionByLabel.path && duplicatedOptionByLabel.path != validOptionLabelPath && !duplicatedOptionByLabel.path.includes(validOptionPath)) {
          duplicatedOptionByLabel.path += ' | ' + validOptionLabelPath;
          duplicatedOptionByLabel.multiplePaths = true;
        }
      }
    }
  }

  filterOptions(selectedOptions, item) {
    const use_totvs_oracle = this.checkIfItUseOracle();
    let valid = true;
    let path = '';
    for (let index = 0; index < selectedOptions.length; index++) {
      const option = selectedOptions[index];
      const valueKeyParam = use_totvs_oracle ? `C_${option.field.totvs_alternative_name}`.toUpperCase() : `COD.${option.field.totvs_table.toUpperCase()}.${option.field.totvs_field.toUpperCase()}`
      if (item[valueKeyParam] != option.value) {
        valid = false;
      }
      if (index === 0) {
        path += option.display.label;
      } else {
        path += ' | ' + option.display.label;
      }
    }
    if (valid) {
      return path;
    } else {
      return valid;
    }
  }

  filterOptionsByLabel(selectedOptions, item) {
    const use_totvs_oracle = this.checkIfItUseOracle();
    let valid = true;
    let path = '';

    for (let index = 0; index < selectedOptions.length; index++) {
      const selectedOption = selectedOptions[index];
      const valueKeyParam = use_totvs_oracle ? `D_${selectedOption.field.totvs_alternative_name}`.toUpperCase() : `DISPLAY.${selectedOption.field.totvs_table.toUpperCase()}.${selectedOption.field.totvs_field.toUpperCase()}`
      if (item[valueKeyParam] != selectedOption.value) {
        valid = false;
      }

      if (index === 0) {
        path += selectedOption.display.label;
      } else {
        path += ' | ' + selectedOption.display.label;
      }
    }

    if (valid) {
      return path;
    } else {
      return valid;
    }
  }

  setWindowData() {
    (window as any).systemFieldsValues = {};
  }

  getApplicantDataByfieldId(field_id) {
    let systemFields = null;
    if (this.data.stepsData) {
      systemFields = this.data.stepsData.steps.currentStep.applicantData;
    } else {
      systemFields = this.data.applicantData;
    }
    if (field_id && systemFields) {
      const field = systemFields.find(field => {
        return field.field_id == field_id;
      });
      if (field) {
        return field.value;
      }
    }
    return "";
  }

  checkIfItUseOracle():boolean {
    if(this.data?.stepsData) {
      return this.data.stepsData.process.use_totvs_oracle;
    }

    if(this.data?.use_totvs_oracle) {
      return this.data.use_totvs_oracle;
    }
    return false;
  }

  public getRelatedData(key) {
    return this.relatedDataStorage[key];
  } 

  public setRelatedData(key, data) {
    this.relatedDataStorage[key] = data;
  }

  public isValidLabel(value) {
    return ![undefined, false, null].includes(value);
  }
}
